"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.glamcornerDomainRegExp = void 0;
exports.glamcornerDomainRegExp = new RegExp("https?://[.a-zA-Z-]*[.]?(glamcorner|herwardrobe).com.au[:0-9]*");
